import React from 'react';
import { useAccountNftStats } from '../hooks/useAccount';
import shinysilverLogo from '../images/shinysilver-Logo.png';
import { useAccount } from 'wagmi';


export default function UserNftSection() {
    const { address: account } = useAccount();
    const nftStats = useAccountNftStats(1);


    return (
        <div className='row'>
            <div className="card-body">
                <h5 className="card-title font-18 font-bold text-dark">Your NFT's </h5>
            </div>
            <div className="col-12">
                <div className='row'>
                    {account ? (
                        nftStats && !nftStats.loading ? (
                            nftStats.nft_list && nftStats.nft_list.length > 0 ? (
                                nftStats.nft_list.map((rowdata, index) => {
                                    let metadata = rowdata.metaData ? JSON.parse(rowdata.metaData) : []
                                    const imageUrl = metadata.image ? getIpfsUrl(metadata.image) : shinysilverLogo;

                                    return (
                                        <div className="col-lg-3" key={index}>
                                            <div className="card profile-card">
                                                <img className="card-img profile-bg" height="250" src={imageUrl} alt="card-img" />
                                                <div className="card-body text-center">
                                                    <div className="row">
                                                        <div className="col">
                                                            <h4 className="m-b-0 nft-text mb-1">{metadata.name ? metadata.name : 0}</h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            ) : (
                                <div className="card">
                                    <div className="text-center mt-5 mb-5">
                                        No BlockStarDAO NFT Found in wallet
                                    </div>
                                </div>
                            )
                        ) : (
                            <div className="card">
                                <div className="text-center mt-5 mb-5">
                                    <div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                </div>
                            </div>
                        )
                    ) : (
                        <div className="card">
                            <div className="text-center mt-5 mb-5">
                                Please Connect Wallet
                            </div>
                        </div>
                    )
                    }
                </div>

            </div>
        </div>
    )
}



const getIpfsUrl = (ipfsPath) => {
    // Remove the 'ipfs://' prefix if it exists
    if (ipfsPath.startsWith("ipfs://")) {
        return `https://alchemy.mypinata.cloud/ipfs/${ipfsPath.replace("ipfs://", "")}`;
    }
    return ipfsPath; // Return as-is if already a valid URL
};